import React from 'react';
import { Container, Row, Col, Button, Card, CardBody, CardText } from 'reactstrap';
import { FaCheck } from 'react-icons/fa'; // Checkmark icon
import labelRoll from '../../../assets/img/icons/common/label-roll.png';

const TraditionalDeviceConfirmationPageContent = () => {
    return (
        <Container className="text-center" style={{ maxWidth: '700px', padding: '20px' }}>
            {/* Confirmation Box */}
            <Card className="mb-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <CardBody>
                    <FaCheck size={40} color="#19aba8" />
                    <h3 className="mt-3">Your DateCodeGenie Portal is ready to use!</h3>
                    <CardText>
                        Please check your email on a desktop device to gain access to your portal.
                    </CardText>
                </CardBody>
            </Card>

            {/* Label Purchase Prompt */}
            <Row className="justify-content-center">
                <Col xs="auto">
                    <img
                        src={labelRoll}
                        alt="Label roll"
                        style={{ width: '100px', marginBottom: '20px' }}
                    />
                </Col>
            </Row>

            <h5>Haven't purchased your labels yet?</h5>
            <p>No Problem. Visit <a href="https://store.ncco.com" style={{ color: 'teal' }}>store.ncco.com</a> to purchase the right products for your business.</p>

            {/* Shop Products Button */}
            <Row>
                <Col>
                    <Button color="primary" href="https://store.ncco.com/food-label-printers" target="_blank" className="mt-3">Shop Printers</Button>
                </Col>
                <Col>
                    <Button color="primary" href="https://store.ncco.com/labels" target="_blank" className="mt-3">Shop Labels</Button>
                </Col>
            </Row>
        </Container>
    );
};

export default TraditionalDeviceConfirmationPageContent;
